"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableRatesCardDesktopTabletView = EditableRatesCardDesktopTabletView;
exports.EditableRatesCardMobileView = EditableRatesCardMobileView;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formik = require("formik");
var _GuaranteedLifetimeWithdrawalBenefitWizardFormControls = require("./GuaranteedLifetimeWithdrawalBenefitWizardFormControls");
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function EditableRatesCardDesktopTabletView(_ref) {
  var {
    arraySelection
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-desktop-tablet-only col-12 col-lg-8"
  }, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
    name: arraySelection
  }, fieldArrayProps => {
    var {
      push,
      remove,
      form
    } = fieldArrayProps;
    var {
      values
    } = form;
    var competitorRowContent = [];
    competitorRowContent.push(/*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col justify-content-center"
    }, /*#__PURE__*/_react.default.createElement("h5", null, "Age range")), /*#__PURE__*/_react.default.createElement("div", {
      className: "col justify-content-center"
    }, /*#__PURE__*/_react.default.createElement("h5", null, "Withdrawal rate"))));
    values[arraySelection].forEach((competitor, index) => {
      competitorRowContent.push(/*#__PURE__*/_react.default.createElement("div", {
        className: "row justify-content-center",
        key: index
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.StartAge, {
        errors: form.errors,
        fieldName: "startAge",
        values: values,
        arrayName: arraySelection,
        index: index
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "glwb rates-margin-top-dash"
      }, " - "), /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.EndAge, {
        errors: form.errors,
        fieldName: "endAge",
        values: values,
        arrayName: arraySelection,
        index: index
      }))), /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.WithdrawalRate, {
        errors: form.errors,
        fieldName: "withdrawalRate",
        values: values,
        arrayName: arraySelection,
        index: index
      }), index == 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0", /*#__PURE__*/_react.default.createElement("div", {
        className: "col"
      })), index > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "col-2 align-items-center"
      }, "\xA0", /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        variant: "none",
        className: "btn-inline",
        onClick: () => {
          (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'click', 'remove');
          remove(index);
        }
      }, "Remove"))));
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-12 col-md-10"
    }, competitorRowContent)), values[arraySelection].length > 9 ? /*#__PURE__*/_react.default.createElement("p", null, "Max. of 10 rows allowed") : /*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      variant: "none",
      className: "btn-inline",
      onClick: () => {
        (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'click', 'addRowButton');
        push({
          startAge: '',
          endAge: '',
          withdrawalRate: ''
        });
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-add"
    }), "\xA0Add row")), /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }));
  })));
}
function EditableRatesCardMobileView(_ref2) {
  var {
    arraySelection
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-mobile-only"
  }, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
    name: arraySelection
  }, fieldArrayProps => {
    var {
      push,
      remove,
      form
    } = fieldArrayProps;
    var {
      values
    } = form;
    var ageColumnContent = [];
    ageColumnContent.push(/*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center"
    }, /*#__PURE__*/_react.default.createElement("h5", null, "Age range")));
    var ratesColumnContent = [];
    ratesColumnContent.push(/*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center"
    }, /*#__PURE__*/_react.default.createElement("h5", null, "Withdrawal rate")));
    values[arraySelection].forEach((competitor, index) => {
      ageColumnContent.push(/*#__PURE__*/_react.default.createElement("div", {
        className: "row justify-content-center",
        key: index
      }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.StartAge, {
        errors: form.errors,
        fieldName: "startAge",
        values: values,
        arrayName: arraySelection,
        index: index
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "glwb rates-margin-top-dash"
      }, " - "), /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.EndAge, {
        errors: form.errors,
        fieldName: "endAge",
        values: values,
        arrayName: arraySelection,
        index: index
      })));
      ratesColumnContent.push(/*#__PURE__*/_react.default.createElement("div", {
        className: "row",
        key: index
      }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.WithdrawalRate, {
        errors: form.errors,
        fieldName: "withdrawalRate",
        values: values,
        arrayName: arraySelection,
        index: index
      }), index > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0", /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        variant: "none",
        className: "btn-inline",
        onClick: () => {
          (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'click', 'remove');
          remove(index);
        }
      }, "Remove"))));
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-12 col-md-4"
    }, ageColumnContent), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-12 col-md-6"
    }, ratesColumnContent)), values[arraySelection].length > 9 ? /*#__PURE__*/_react.default.createElement("p", null, "Max. of 10 rows allowed") : /*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      variant: "none",
      className: "btn-inline",
      onClick: () => {
        (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'click', 'addRowButton');
        push({
          startAge: '',
          endAge: '',
          withdrawalRate: ''
        });
      }
    }, /*#__PURE__*/_react.default.createElement("h5", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-add"
    }), "\xA0Add row"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }));
  })));
}